import { ChevronDownIcon } from "@heroicons/react/24/outline"
import { Dropdown } from "antd"
import { Button } from "components"
import { ComponentProps } from "react"

interface Props {
  items: Items[] | undefined
  title?: string
  color?: "primary" | "secondary"
}

type Items = {
  key: string
  label: React.ReactNode
} | null

const ActionsButton = ({ items, title, color = "primary" }: Props) => {
  return (
    <>
      <div className="h-full">
        <Dropdown
          trigger={["click"]}
          menu={{
            items,
          }}
          className=""
        >
          <div className="">
            <button className="lg:hidden border rounded-[4px] block h-full px-1 py-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M10.5 19C10.5 20.1 11.4 21 12.5 21C13.6 21 14.5 20.1 14.5 19C14.5 17.9 13.6 17 12.5 17C11.4 17 10.5 17.9 10.5 19Z" />
                <path d="M10.5 5C10.5 6.1 11.4 7 12.5 7C13.6 7 14.5 6.1 14.5 5C14.5 3.9 13.6 3 12.5 3C11.4 3 10.5 3.9 10.5 5Z" />
                <path
                  d="M12.5 14C13.6 14 14.5 13.1 14.5 12C14.5 10.9 13.6 10 12.5 10C11.4 10 10.5 10.9 10.5 12"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div className="hidden lg:block">
              <Button
                color={color}
                className=" items-center"
              >
                {title ? title : "Manage"}
                <ChevronDownIcon
                  className={`w-4 h-4 ml-2 ${
                    color === "primary" ? "text-a11y" : "text-padeBlack"
                  }`}
                />
              </Button>
            </div>
          </div>
        </Dropdown>
      </div>
    </>
  )
}

export default ActionsButton
